<template>
  <div class="container-fluid p-0">
    <PageTitle
      :title="$t('coralSol.ocorrencias')"
      :titleAdd="$t('coralSol.addOcorrencia')"
      :isAdd="true"
      :hasExportCSV="true"
      @onExportCSV="exportCSV"
      />

    <!-- tabela -->
    <div class="row">
      <div class="col-12 d-flex">
        <div class="card flex-fill">
          <div class="card-body box-dashboard p-0">
            <CoralsolOcorrenciasTable @orderBy="orderBy" @search="search" :items="items"/>
          </div>
        </div>
      </div>
    </div>
    <!-- /tabela -->
  </div>
</template>

<script>
import axios from 'axios'
import PageTitle from '@/components/shared/PageTitle'
import CoralsolOcorrenciasTable from './CoralsolOcorrenciasTable.vue'

export default {
  name: 'CoralsolOcorrencias',
  components: { CoralsolOcorrenciasTable, PageTitle },
  data () {
    return {
      items: [],
      dataOrderBy: {}
    }
  },
  methods: {
    async exportCSV () {
      this.$store.dispatch('showPreload')

      const params = {
        ...this.$store.state.formSearch,
        Page: this.$store.state.currentPage,
        PageSize: 9999
      }

      try {
        const response = await axios.get('/CoralsolOccurrence/getlistforexport', { params })
        const data = response.data.items

        if (!data || !data.length) {
          this.$toasted.global.defaultError({ msg: 'Nenhum dado encontrado para exportação.' })
          return
        }

        const baseURL = axios.defaults.baseURL.replace(/\/$/, '')

        const headers = [
          'ID',
          'Data',
          'Observador',
          'Localidade',
          'Colaborador',
          'Profundidade',
          'Altura',
          'Largura',
          'Acesso',
          'Cobertura',
          'Geomorfologia',
          'Observações',
          'Coordenadas',
          'Link Foto Subaquática',
          'Link Foto Superfície'
        ].join(';')

        const rows = data.map(item => {
          const subaquaticaUrl = item.subaquatica_photo
            ? `${baseURL}/Upload/UploadImageCoralSol/${item.occurrence_id}/${item.subaquatica_photo}`
            : ''

          const superficieUrl = item.superficie_photo
            ? `${baseURL}/Upload/UploadImageCoralSol/${item.occurrence_id}/${item.superficie_photo}`
            : ''

          return [
            item.occurrence_id || '',
            item.date || '',
            item.observer || '',
            item.locality_name || '',
            item.surname || '',
            item.depth || '',
            item.height || '',
            item.width || '',
            item.access || '',
            item.coverage || '',
            item.geomorphology || '',
            item.observation || '',
            item.spot_coords || '',
            subaquaticaUrl,
            superficieUrl
          ].map(value =>
            typeof value === 'string'
              ? `"${value.replace(/"/g, '""')}"`
              : value != null ? value : ''
          ).join(';')
        })

        const csv = `${headers}\n${rows.join('\n')}`

        // Nome dinâmico do arquivo
        const today = new Date().toISOString().split('T')[0] // yyyy-mm-dd
        const filename = `ocorrencias_export_${today}.csv`

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        this.$toasted.global.defaultSuccess({ msg: 'Exportação realizada com sucesso!' })
      } catch (error) {
        this.$toasted.global.defaultError({ msg: 'Erro ao exportar os dados.' })
        console.error('Erro exportCSV Ocorrência:', error)
      } finally {
        this.$store.dispatch('hidePreload')
      }
    },
    clear () {
      this.$store.commit('clearFormSearch')
    },
    orderBy (dataOrderBy) {
      this.$store.state.dataOrderBy = dataOrderBy
      this.search()
    },
    setFormOrderBy () {
      this.$store.state.formSearch.OrderByIDAcs = this.$store.state.dataOrderBy.OrderByIDAcs
      this.$store.state.formSearch.OrderByIDDesc = this.$store.state.dataOrderBy.OrderByIDDesc
      this.$store.state.formSearch.OrderBySpotCoordsAcs = this.$store.state.dataOrderBy.OrderBySpotCoordsAcs
      this.$store.state.formSearch.OrderBySpotCoordsDesc = this.$store.state.dataOrderBy.OrderBySpotCoordsDesc
      this.$store.state.formSearch.OrderByDateAcs = this.$store.state.dataOrderBy.OrderByDateAcs
      this.$store.state.formSearch.OrderByDateDesc = this.$store.state.dataOrderBy.OrderByDateDesc
      this.$store.state.formSearch.OrderByDepthAcs = this.$store.state.dataOrderBy.OrderByDepthAcs
      this.$store.state.formSearch.OrderByDepthDesc = this.$store.state.dataOrderBy.OrderByDepthDesc
      this.$store.state.formSearch.LocalityIDAcs = this.$store.state.dataOrderBy.LocalityIDAcs
      this.$store.state.formSearch.LocalityIDDesc = this.$store.state.dataOrderBy.LocalityIDDesc
      this.$store.state.formSearch.OrderByAccessAcs = this.$store.state.dataOrderBy.OrderByAccessAcs
      this.$store.state.formSearch.OrderByAccessDesc = this.$store.state.dataOrderBy.OrderByAccessDesc
      this.$store.state.formSearch.OrderByCoverageAcs = this.$store.state.dataOrderBy.OrderByCoverageAcs
      this.$store.state.formSearch.OrderByCoverageDesc = this.$store.state.dataOrderBy.OrderByCoverageDesc
    },
    async search () {
      this.$store.dispatch('showPreload')

      this.setFormOrderBy()
      const params = this.$store.state.formSearch
      params.Page = this.$store.state.currentPage
      params.PageSize = this.$store.state.perPage
      await axios.get('/CoralsolOccurrence/getallgrid', { params })
        .then(response => {
          this.$store.state.currentPage = response.data.page
          this.$store.state.countList = response.data.count
          this.items = response.data.items
        })
    }
  },
  async created () {
    this.$store.state.formSearch.pending_analysis = true
    await this.search()
  }
}
</script>
